var exports = {
  "zr": "ShopierPurchaseSection.module__root___TnpLQ2",
  "wx": "ShopierPurchaseSection.module__header___TnpLQ2",
  "DD": "ShopierPurchaseSection.module__title___TnpLQ2",
  "VA": "ShopierPurchaseSection.module__subtitle___TnpLQ2",
  "yH": "ShopierPurchaseSection.module__planGrid___TnpLQ2",
  "cz": "ShopierPurchaseSection.module__planCard___TnpLQ2",
  "AS": "ShopierPurchaseSection.module__planCardFeatured___TnpLQ2",
  "F6": "ShopierPurchaseSection.module__ribbon___TnpLQ2",
  "ts": "ShopierPurchaseSection.module__planTop___TnpLQ2",
  "L0": "ShopierPurchaseSection.module__planIcon___TnpLQ2",
  "KS": "ShopierPurchaseSection.module__planTitle___TnpLQ2",
  "dH": "ShopierPurchaseSection.module__saveBadge___TnpLQ2",
  "y3": "ShopierPurchaseSection.module__priceRow___TnpLQ2",
  "q9": "ShopierPurchaseSection.module__price___TnpLQ2",
  "Bz": "ShopierPurchaseSection.module__pricePeriod___TnpLQ2",
  "Ly": "ShopierPurchaseSection.module__priceHint___TnpLQ2",
  "qT": "ShopierPurchaseSection.module__features___TnpLQ2",
  "AD": "ShopierPurchaseSection.module__featureIcon___TnpLQ2",
  "B1": "ShopierPurchaseSection.module__subscribe___TnpLQ2",
  "TD": "ShopierPurchaseSection.module__subscribeFeatured___TnpLQ2",
  "b6": "ShopierPurchaseSection.module__history___TnpLQ2",
  "AK": "ShopierPurchaseSection.module__historyHeader___TnpLQ2",
  "Zl": "ShopierPurchaseSection.module__historyTitle___TnpLQ2",
  "ee": "ShopierPurchaseSection.module__ghostButton___TnpLQ2",
  "ZL": "ShopierPurchaseSection.module__spinning___TnpLQ2",
  "t0": "ShopierPurchaseSection.module__spin___TnpLQ2",
  "PI": "ShopierPurchaseSection.module__historyList___TnpLQ2",
  "qm": "ShopierPurchaseSection.module__historyItem___TnpLQ2",
  "M_": "ShopierPurchaseSection.module__historyMain___TnpLQ2",
  "wd": "ShopierPurchaseSection.module__historyPlan___TnpLQ2",
  "O7": "ShopierPurchaseSection.module__historyCode___TnpLQ2",
  "Br": "ShopierPurchaseSection.module__historyDate___TnpLQ2",
  "h5": "ShopierPurchaseSection.module__status___TnpLQ2",
  "Wp": "ShopierPurchaseSection.module__statusPending___TnpLQ2",
  "SP": "ShopierPurchaseSection.module__statusGranted___TnpLQ2",
  "bM": "ShopierPurchaseSection.module__statusReview___TnpLQ2",
  "a2": "ShopierPurchaseSection.module__statusRefunded___TnpLQ2",
  "yj": "ShopierPurchaseSection.module__help___TnpLQ2",
};

module.exports = exports;
